<template>
  <div>
    <v-app-bar
      app
      class="white hidden-sm-and-down"
      height="80px"
      outlined
      style="box-shadow: 0 2px 4px rgb(0 0 0 / 0%); padding-left: 10px"
    >

      <router-link to="/">
        <!-- <v-img :src="require('@/assets/logo_org.png')" style="min-width:123px"> </v-img> -->
        <!-- <v-img :src="require('@/assets/image/logo_org_old.png')"></v-img> -->
        <!-- <v-img :src="require('@/assets/image/logo_org_old.png')" style="width:10%;"> </v-img> -->
        <v-img :src="require('@/assets/image/Solva_Logo.svg')" style="width:90%;" @click=" setActiveStyle('home')"></v-img>
      </router-link>
      <v-spacer style="color: red"></v-spacer>
      <div>
        <v-btn
          text
          router
          :to="'/'"
          class="text-capitalize"
          style="padding: 0 0"
          @click="setActiveStyle('home')"
        >
          Home
        </v-btn>
        <v-divider v-if="homeActive"></v-divider>
      </div>

      <div>
        <v-btn
          text
          router
          :to="'/about'"
          class="text-capitalize"
          @click="setActiveStyle('about')"
          >About</v-btn
        >
        <v-divider v-if="about"></v-divider>
      </div>
      <div>
        <v-btn
          text
          router
          :to="'/contactus'"
          class="text-capitalize"
          @click="setActiveStyle('contact')"
        >
          Contact Us
        </v-btn>
        <v-divider v-if="contact"></v-divider>
      </div>

      <div>
        <v-btn
          id = "projectBtn"
          text
          router
          :to="'/projects'"
          class="text-capitalize"
          @click="setActiveStyle('projects')"
          >Projects</v-btn
        >
        <v-divider v-if="projects"></v-divider>
      </div>
      <div>
        <v-btn
          text
          v-if="isLoggedin"
          router
          :to="'/dashboard'"
          class="text-capitalize"
          @click="setActiveStyle('myProjects')"
        >
          My Projects
        </v-btn>
        <v-divider v-if="myProjects"></v-divider>
      </div>
      <div>
        <v-btn
          text
          v-if="isAdmin"
          router
          :to="'/admin'"
          class="text-capitalize"
          @click="setActiveStyle('admin')"
          >Admin
        </v-btn>
        <v-divider v-if="admin"></v-divider>
      </div>

      <div>
        <v-btn
          text
          v-if="isLoggedin"
          router
          :to="'/settings'"
          class="text-capitalize"
          @click="setActiveStyle('settings')"
        >
          Settings
        </v-btn>
        <v-divider v-if="settings"></v-divider>
      </div>
      <div>
        <v-btn
          text
          v-if="!isLoggedin"
          router
          :to="'/login'"
          class="text-capitalize"
          @click="setActiveStyle('loginRegister')"
        >
          Login/Register
        </v-btn>
        <v-divider v-if="loginRegister"></v-divider>
      </div>
      <v-btn
        text
        v-if="isLoggedin"
        @click="setLogout()"
        class="text-capitalize"
      >
        Logout
      </v-btn>
    </v-app-bar>

    <div class="hidden-md-and-up">
      <v-app-bar flat grey class="hidden-md-and-up" absolute height="80px">
        <v-btn text @click="toggleDrawer">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
        <v-app-bar-title class="grey--text">
          <div class="subtitle-2">
            <v-img :src="require('@/assets/logo_org.png')" width="70px"></v-img>
            Evaluate the value of distributed solar and storage
          </div>
        </v-app-bar-title>
      </v-app-bar>
      <v-navigation-drawer v-model="drawer" absolute temporary>
        <v-divider></v-divider>
        <v-list>
          <v-list-item :to="'/'">
            <v-list-item-icon>
              <v-icon color="grey darken-1"> mdi-home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="'/about'">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-account-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>About us</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="'/projects'">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-view-list</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Projects</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="isAdmin" :to="'/admin'">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-view-list</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Admin</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="isLoggedin" :to="'/dashboard'">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-account-settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>My Projects</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item v-if="isLoggedin" :to="`/report${null}`">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-chart-areaspline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Report</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item :to="'/contactus'">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-account-check</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Contact Us</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="!isLoggedin" :to="'/login'">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-login</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Login/Register</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>

        <v-list>
          <v-list-item v-if="isLoggedin" :to="'/settings'">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-account-settings</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Settings</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="isLoggedin" @click="setLogout()">
            <v-list-item-icon>
              <v-icon color="grey darken-1">mdi-logout</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </div>
  </div>
</template>

<script>
import settingsUtility from "@/utility/settingsUtility";

export default {
  name: "Nav",
  data() {
    return {
      drawer: null,
      homeActive: false,
      about: false,
      contact: false,
      projects: false,
      myProjects: false,
      admin: false,
      settings: false,
      loginRegister: false,
    };
  },
  props: ["message"],
 created(){
    const page=this.$router.currentRoute.name;
    this.setActiveStyle(page);
 },
 
  methods: {
    setActiveStyle(btn) {
      if (btn === "home") {
        this.homeActive = true;
        this.about = false;
        this.contact = false;
        this.projects = false;
        this.myProjects = false;
        this.admin = false;
        this.settings = false;
        this.loginRegister = false;
      }
      if (btn === "about") {
        this.homeActive = false;
        this.about = true;
        this.contact = false;
        this.projects = false;
        this.myProjects = false;
        this.admin = false;
        this.settings = false;
        this.loginRegister = false;
      }
      if (btn === "contact") {
        this.homeActive = false;
        this.about = false;
        this.contact = true;
        this.projects = false;
        this.myProjects = false;
        this.admin = false;
        this.settings = false;
        this.loginRegister = false;
      }
      if (btn === "projects") {
        this.homeActive = false;
        this.about = false;
        this.contact = false;
        this.projects = true;
        this.myProjects = false;
        this.admin = false;
        this.settings = false;
        this.loginRegister = false;
      }
      if (btn === "myProjects" || btn === "Dashboard" ) {
        this.homeActive = false;
        this.about = false;
        this.contact = false;
        this.projects = false;
        this.myProjects = true;
        this.admin = false;
        this.settings = false;
        this.loginRegister = false;
      }
      if (btn === "admin") {
        this.homeActive = false;
        this.about = false;
        this.contact = false;
        this.projects = false;
        this.myProjects = false;
        this.admin = true;
        this.settings = false;
        this.loginRegister = false;
      }
      if (btn === "settings") {
        this.homeActive = false;
        this.about = false;
        this.contact = false;
        this.projects = false;
        this.myProjects = false;
        this.admin = false;
        this.settings = true;
        this.loginRegister = false;
      }
      if (btn === "loginRegister" || btn ==='Login') {
        this.homeActive = false;
        this.about = false;
        this.contact = false;
        this.projects = false;
        this.myProjects = false;
        this.admin = false;
        this.settings = false;
        this.loginRegister = true;
      }
    },
    setLogout() {
      settingsUtility.methods.setLogout();
      window.location.href = "/login";
    },
    toggleDrawer() {
      this.drawer = !this.drawer;
    },
  },
  computed: {
    isAdmin() {
      return settingsUtility.methods.isAdmin();
    },
    isLoggedin() {
      return settingsUtility.methods.getLoginStatus();
    },
  },
};
</script>
<style scoped>
.v-btn--active {
  /* border-image: linear-gradient(
      to right,
      #ffffff 16%,
      #6bbc56 0%,
      #2fa9d8 55%,
      #2fa9d8 80%,
      #ffffff 10%
    )
    1; */
  /* border-image: linear-gradient(
      to right,
      #ffff 1%,
      #6bbc56 50%,
      #2fa9d8 50%,
      #2fa9d8 65%,
      #ffff
    )
    1;
  border-bottom: 2.0pt solid #2fa9d8 !important; */
  /* background-color: white; */
  /* max-width: 3pt; */
  /* opacity: 1 !important; */
}

.theme--light.v-btn--active::before {
  opacity: 0 !important;
}

.v-btn.v-size--default {
  width: auto;
  font-size: 14pt;
  font-weight: 400;
  color: #505252;
  letter-spacing: 0.005em;
}
.v-btn:not(.v-btn--round).v-size--default {
  font-size: 13pt;
  height: 36px;
  min-width: 70px;
  padding: 2px 12px;
  letter-spacing: 0.005em;
}

.theme--light.v-divider {
  border-image: linear-gradient(to right, #6bbc56 40%, #2fa9d8 50%, #2fa9d8) 1;
  border-width: 1px !important;
  margin-left: 9.0pt;
  margin-right: 8.5pt;
}
</style>